import { Button, Grid2, Typography,useMediaQuery,FormHelperText,FormControl,TextField } from "@mui/material";
import referpic from "../../../ui-utils/latestPics/refer1.svg";
import ReferWebViewStyles from "./WebView.module.css";
import OtpInput from "react-otp-input";
import { useState,useRef,useEffect } from "react";
import axios from "axios";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { backendHosts } from "../../../ui-utils/apiConfig";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useLanguage } from "../../../Context/LangContext";
import en from "../../../i18n/English/Home/refer.json";
import hi from "../../../i18n/Hindi/Home/refer.json";
import kn from "../../../i18n/Kannada/Home/refer.json";
import ma from "../../../i18n/Marathi/Home/refer.json";
import gu from "../../../i18n/Gujarati/Home/refer.json";
export default function WebView() {
  const isSmallScreen = useMediaQuery("(max-width:1100px)");
  const [open,setOpen]=useState(false)
  const [refcode, setRefCode] = useState("");
  const [mobile,setMobile]=useState("")
  const [isValid, setIsValid] = useState(false);
  const [link,setLink]=useState("")
  const [linkPage, setLinkPage] = useState(false);
  const [refresData, setRefResData] = useState(null);
  const [errMsg, setErrMsg] = useState("");
  const [otp, setOtp] = useState("");

  const firstRenderRef = useRef(true);

  const { language } = useLanguage();
  const translations = { en, hi, kn ,gu ,ma  };
  const t = translations[language] || translations.en;

  useEffect(() => {
    firstRenderRef.current = false; // Mark first render as completed after first mount
  }, [])

  const handleValidate =async()=>{

     if (!refcode) {
      setErrMsg("Client ID is required.");
      return;
    }
    const payload ={
      data:{
        client_id:refcode
      }
    }
    // setIsValid(true)
    try{
      const respone = await axios.post(`${backendHosts.ADMIN}/api/public/otp`, payload)
      if (respone.data.data?.data?.success) {
        setErrMsg("")
        setRefResData(respone.data?.data?.data)
        setMobile(respone.data?.data?.data?.mobile)
        setIsValid(true)
      } else {
        setErrMsg("Please enter a valid client ID")
      }
    }catch(err){
       console.log(err)
    }

  }



  const hadleCancelRefferal = () => {
    setOpen(false)
    setIsValid(false)
    setMobile("")
    setOtp("")
    setErrMsg("")
    setRefCode("")
  };

  const handleverifyReferralOTP =async()=>{

     if (!otp) {
      setErrMsg("OTP is required.");
      return;
    }
    const payload = {
      data: {
        client_id: refcode,
        mobile:mobile,
        otp:otp
      }
    }
    try {
      const respone = await axios.post(`${backendHosts.ADMIN}/api/public/otp/verify`, payload)
      if (respone.data.data?.data?.success) {
        setLinkPage(true)
        setLink(respone.data?.data?.data?.link)
        setErrMsg("")
      } else {
        setErrMsg(respone.data.data?.data?.message)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(
      link
    );
  }
  return (
    <>
      <Grid2 className={ReferWebViewStyles.web_main}>
        <Grid2 className={linkPage ? ReferWebViewStyles.linkCard : (open ? ReferWebViewStyles.inputMainCard : ReferWebViewStyles.web_ref_card1)}>
          {firstRenderRef.current ? (
            <AnimationOnScroll
              animateIn="animate__fadeInLeft"
              animateOnce={true}
              className={ReferWebViewStyles.customFadeInLeft}
            >
              <img src={referpic} alt="refer logo" className={ReferWebViewStyles.img} />
            </AnimationOnScroll>
          ) : (
            <img src={referpic} alt="refer logo" className={ReferWebViewStyles.img} />
          )}

            {
              linkPage ? <>
              <Grid2 >

                <Typography className={ReferWebViewStyles.web_refcard_txt}>
                  Find your link below
                  {/* {t.findYourLink} */}
                </Typography>

                <Grid2 className={ReferWebViewStyles.ref_card6}>
                  <Grid2 className={ReferWebViewStyles.ref_card3}>
                    <Typography className={ReferWebViewStyles.reflinktxt}>
                     {link}
                  </Typography>

                  <Grid2
                    style={{

                      marginRight: "10px",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    onClick={handleCopy}
                  >
                    <Grid2
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                        <FileCopyIcon style={{
                         color:"#ffffff"
                        }} />
                    </Grid2>
                    <Grid2
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        style={{
                            color: "#ffffff",
                          fontSize: "12px",
                          fontFamily: "Inter700",
                          "@media (max-width: 1500px)": {
                            fontSize: "12px"
                          }
                        }}
                      >
                        copy
                          {/* {t.copy} */}
                      </Typography>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>
              </Grid2>
              </> : <>
              {
                open ? <>
                  {
                    isValid ? <>
                      <Grid2 className={ReferWebViewStyles.optCard}>
                        <Typography className={ReferWebViewStyles.web_refcard_txt}>
                          Referral program
                            {/* {t.referralProgram} */}
                        </Typography>
                        {/* <Typography className={ReferWebViewStyles.otpTxt}>Enter OTP</Typography> */}

                        <Grid2
                          style={{
                            width: "100%",
                            display: "flex",
                            alignContent: "flex-end",
                          }}
                        >
                          <Grid2 className={ReferWebViewStyles.optinnercard}>
                            <Typography className={ReferWebViewStyles.otpSubTxt}>
                              Please provide us the {refresData?.message} linked with
                              client code {refcode}{" "}
                              {/* Please provide us the OTP, sent to your <br></br>
                          phone number ******7708 linked with client code AAA384 */}
                              {/* {this.state.mobilenumber.substring(6, 10)}  */}
                              {/* {this.state.clentid.toString().toUpperCase()} */}
                            </Typography>
                            <Grid2
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "20px",
                              }}
                            >
                              <OtpInput
                                numInputs={4}
                                value={otp}
                                shouldAutoFocus={true}
                                inputStyle={{
                                  backgroundColor: "transparent",
                                  width: "40px",
                                  height: "40px",
                                  border: "none",
                                  marginRight: "5px",
                                  color: "#FFFFFF",
                                  fontSize: "20px",
                                  fontFamily: "Inter500",
                                  borderBottom: "1px solid #FFFFFF",
                                }}
                                containerStyle={{
                                  justifyContent: "center",
                                  borderBottom: "10",
                                }}
                                renderInput={(props) => <input {...props} />}
                                // onChange={(e) => setOtp(e.target.value)}
                                onChange={(value) => setOtp(value)}
                              />

                            </Grid2>
                              {errMsg && (
                                <FormHelperText sx={{ color: "#E93333 !important", fontFamily: "Inter400 !important", fontSize: "16px !important", display: "flex", justifyContent: "center", alignContent: "center",marginTop:"10px" }}>
                                  {errMsg}
                                </FormHelperText>
                              )}
                          </Grid2>
                        </Grid2>

                        <Grid2 className={ReferWebViewStyles.inputButCard}>
                          <Button className={ReferWebViewStyles.inputbut} onClick={hadleCancelRefferal}>
                            Cancel
                          </Button>
                          <Button className={ReferWebViewStyles.inputbut} onClick={handleverifyReferralOTP}>
                            Submit
                          </Button>
                        </Grid2>
                      </Grid2>

                    </> : <>
                      <Grid2 className={ReferWebViewStyles.inputCard}>
                        <Typography className={ReferWebViewStyles.web_refcard_txt}>
                          {/* Referral program */}
                              {t.referralProgram}
                        </Typography>
                        <FormControl className={ReferWebViewStyles.ref_card7} variant="standard">
                          <TextField
                            variant="standard" // or 'outlined', 'filled' based on your design
                            label={t.enterClientCode} // The label text
                            value={refcode}
                            sx={{
                              // Label styles
                              "& .MuiInputLabel-root": {
                                color: "#FFFFFF", // Default label color
                                fontFamily: "Inter400 !important", // Label font family
                                fontSize: "20px", // Default label font size
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#FFFFFF", // Label color when focused
                                fontSize: "22px", // Optional: Increase font size when focused
                              },
                              "& .MuiInputLabel-root.Mui-error": {
                                color: "#FFFFFF", // Label color in case of error
                              },
                              "& .MuiInput-underline:before": {
                                borderBottomColor: "#FFFFFF",
                              },
                              "& .MuiInput-underline:hover:before": {
                                borderBottomColor: "#FFFFFF",
                              },
                              "& .MuiInput-underline:after": {
                                borderBottomColor: "#FFFFFF",
                              },

                              "& .MuiInputBase-input": {
                                color: "#FFFFFF",
                                fontFamily: "Inter400",
                                fontSize: "20px",
                                padding: "5px 0",
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                fontFamily: "Inter400 !important", // Ensures the font family applies
                                fontSize: "22px", // Custom label font size

                              },
                            }}
                            onChange={(e) => setRefCode(e.target.value)}
                          />

                          {errMsg && (
                            <FormHelperText sx={{ color: "#E93333 !important", fontFamily: "Inter400 !important", fontSize: "16px !important" }}>
                              {errMsg}
                            </FormHelperText>
                          )}
                        </FormControl>
                        <Grid2 className={ReferWebViewStyles.inputButCard}>
                          <Button className={ReferWebViewStyles.inputbut} onClick={() => {    setOpen(false)
                            setErrMsg("")
                            setRefCode("")
                           }}>
                            {t.cancel}
                          </Button>
                          <Button className={ReferWebViewStyles.inputbut} onClick={handleValidate}>
                            {t.validate}
                          </Button>
                        </Grid2>
                      </Grid2></>
                  }

                </> : <>
                      {firstRenderRef.current ? (
                        <AnimationOnScroll
                          animateIn="animate__fadeInRight"
                          animateOnce={true}
                          className={ReferWebViewStyles.customFadeInRight}
                        >
                          <Grid2>
                            <Typography className={ReferWebViewStyles.web_refcard_txt} style={{ fontWeight: 600 }}>
                              {/* Referral program */}
                              {t.referralProgram}
                            </Typography>
                            <Typography className={ReferWebViewStyles.web_refcard_txt2} style={{ marginTop: "4%" }}>
                              {/* This involves 2 very simple steps. */}
                              {t.thisInvolvesSteps}
                            </Typography>
                            <Typography className={ReferWebViewStyles.web_refcard_txt1} sx={{ paddingTop: "5px" }}>
                              <span className={ReferWebViewStyles.refsub_text2}>
                                {/* Generate your referral code */}
                                {t.generateReferralCode}
                              </span>{" "}
                              {/* by keying your account number and share the link within your
                              network. */}
                              {t.text}
                            </Typography>
                            <Grid2 style={{ marginTop: "4%", marginBottom: "4%" }}>
                              <Button className={ReferWebViewStyles.web_referral_but2} onClick={() => setOpen(true)}>
                                {/* Refer */}
                                {t.refer}
                              </Button>
                            </Grid2>
                          </Grid2>
                        </AnimationOnScroll>
                      ) : (
                        <Grid2>
                            <Typography className={ReferWebViewStyles.web_refcard_txt} style={{ fontWeight: 600 }}>
                            {/* Referral program */}
                              {t.referralProgram}
                          </Typography>
                          <Typography className={ReferWebViewStyles.web_refcard_txt2} style={{ marginTop: "4%" }}>
                            {/* This involves 2 very simple steps. */}
                              {t.thisInvolvesSteps}
                          </Typography>
                          <Typography className={ReferWebViewStyles.web_refcard_txt1} sx={{ paddingTop: "5px" }}>
                            <span className={ReferWebViewStyles.refsub_text2}>
                              {/* Generate your referral code */}
                                {t.generateReferralCode}
                            </span>{" "}
                            {/* by keying your account number and share the link within your
                            network. */}
                              {t.text}
                          </Typography>
                          <Grid2 style={{ marginTop: "4%", marginBottom: "4%" }}>
                            <Button className={ReferWebViewStyles.web_referral_but2} onClick={() => setOpen(true)}>
                              {/* Refer */}
                                {t.refer}
                            </Button>
                          </Grid2>
                        </Grid2>
                      )}

                </>
              }
              </>
            }








        </Grid2>
      </Grid2>
    </>
  );
}
